import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getMeetingLogs } from '../api/meetingApi'

/**
 * İşlem Geçmişi sunucu-durumu (046). Yalnız {@code enabled} (dialog açık) iken sorgulanır — buton her
 * detay render'ında gereksiz istek atmasın. id geçersizse pasif.
 *
 * <p>Aktif dil ({@code i18n.language}) key'e girer: işlem adı ({@code operationName}, REF_OPERATION_CODE)
 * sunucuda {@code Accept-Language}'e göre çözülür → dil TR↔EN değiştiğinde eski dilde kalmasın.
 */
export function useMeetingLogs(id: number | null, enabled: boolean) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['meeting-logs', id, i18n.language],
    queryFn: () => getMeetingLogs(id as number),
    enabled: enabled && id != null && !Number.isNaN(id),
  })
}
